import MessageBox from "../components/MessageBox";
import SocialMedia from "../components/SocialMedia";
import { Flex, Text, Button, Image, Box } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const LoadingAnimation = () => {
  return (
    <motion.div
      animate={{ opacity: [0.3, 1, 0.3] }}
      transition={{ duration: 1.5, repeat: Infinity }}
      style={{ fontSize: "20px", fontWeight: "400", color: "#fff" }}
    >
      000
    </motion.div>
  );
};

const Component = () => {
  const [showScroller, setShowScroller] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [usersCount, setUsersCount] = useState(0);

  useEffect(() => {
    fetch("https://api.socialproject.pl/discordOnline")
      .then((response) => response.json())
      .then((data) => {
        setUsersCount(data.userCount);
        console.log(data);
        setLoaded(true);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setShowScroller(window.innerHeight > 800);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Flex direction={"row"}>
      <Flex
        direction={"column"}
        padding={"87px 0px"}
        width={"650px"}
        gap={"34px"}
      >
        <MessageBox>
          <Text as="span" role="img" aria-label="waving hand">
            👋
          </Text>
          <Text as="span" ml="8px">
            Nie masz psychy, nie dołączysz do nas!
          </Text>
        </MessageBox>
        <Text fontWeight={"400"} fontSize={"54px"} lineHeight={"120%"}>
          Cześć, dołącz do polskiego serwera RPG
          <Text as={"span"} fontWeight={"600"}>
            {" "}
            socialproject.pl
          </Text>
        </Text>
        <Text
          fontWeight={"400"}
          fontSize={"20px"}
          lineHeight={"145%"}
          mr={"85px"}
          color={"#B6B6B6"}
        >
          Staw czoła rozgrywce, rozwijaj swój majątek, współpracuj z innymi i
          baw się świetnie w unikalnych{" "}
          <Text as={"span"} color={"#fff"}>
            wydarzeniach
          </Text>{" "}
          oraz{" "}
          <Text as={"span"} color={"#fff"}>
            aktywnościach
          </Text>
          .
        </Text>
        <Flex direction={{ base: "column-reverse", md: "row" }} gap={"26px"}>
          <Button
            fontWeight={"400"}
            fontSize={"18px"}
            width={"fit-content"}
            as={"a"}
            href={"https://discord.socialproject.pl"}
            target="_blank"
            lineHeight="40px"
            height={"40px"}
            style={{ textDecoration: "none" }}
            backgroundColor={"#fff"}
            color={"#000"}
            _hover={{ backgroundColor: "#d6d6d6" }}
          >
            Dołącz na discord
          </Button>
          <Flex direction={"row"} gap={"10px"} alignItems={"center"}>
            <Image src="/dot.svg" alt="dot" width="24px" height="24px" />
            <Flex
              direction={"row"}
              gap={"1"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              {!loaded ? (
                <LoadingAnimation />
              ) : (
                <Text fontSize={"20px"} color={"#fff"} lineHeight={"24px"}>
                  {usersCount}{" "}
                </Text>
              )}
              <Text as="span" color={"#B6B6B6"} fontSize={"20px"}>
                użytkowników online
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <SocialMedia />
      </Flex>
      <Box
        position="absolute"
        right="calc(50% - 750px)"
        top="50px"
        width="auto"
        display={{ base: "none", xl: "block" }}
        maxWidth="760px"
        zIndex={1}
        sx={{
          maskImage:
            "linear-gradient(to bottom, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0))",
          WebkitMaskImage:
            "linear-gradient(to bottom, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0))",
        }}
      >
        <Image
          src="/bg-image.png"
          alt="Postacie z gry"
          width="100%"
          objectFit="contain"
          draggable="false"
        />
      </Box>
      {showScroller && (
        <Box display={{ base: "none", md: "block" }}>
          <div class="scroll-downs">
            <div class="mousey">
              <div class="scroller"></div>
            </div>
          </div>
        </Box>
      )}
    </Flex>
  );
};

export default Component;
